import { purchaseService } from '@eir/services';
import { useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import { PageHeader } from '../../components';

const PaymentView = () => {
  const match = useRouteMatch('/pay/:paymentProvider/:quoteId');
  const [error, setError] = useState(false);

  const redirectToPaymentProvider = async () => {
    try {
      const data = await purchaseService(
        'PetsonAPI',
        match.params.paymentProvider,
        match.params.quoteId,
      );
      window.location.replace(data.redirectUrl);
    } catch (err) {
      setError(true);
      console.log(err);
    }
  };

  redirectToPaymentProvider();

  return (
    <PaymentContainer>
      <Header>
        <LogoContainer>
          <Logo
            src='https://d2l0gvltru79ov.cloudfront.net/partners/petson/petson_logo_black.svg'
            alt='Petson'
          />
        </LogoContainer>
        <h1>{error ? 'Något gick fel' : 'Vänligen vänta...'}</h1>
      </Header>
      {error && (
        <main>
          Det gick inte att genomföra betalningen. Vänligen kontakta vår
          kundeservice på telefon <Phone>08-14 20 00</Phone> eller e-post
          hej@petson.se så hjälper vi dig.
        </main>
      )}
    </PaymentContainer>
  );
};

export default PaymentView;

const PaymentContainer = styled.div`
  width: 100%;
  max-width: 56.25rem;
  margin: 1.875rem auto;
  line-height: 1.7;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;

  main {
    padding: 0 0.625rem;

    @media (min-width: 48rem) {
      padding: 0 1.875rem;
    }
  }
`;

const Phone = styled.span`
  white-space: nowrap;
`;

const Header = styled.header`
  margin: auto;
  background-color: #fff;
  padding: 0rem 1rem;
`;

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 4rem;
  margin-bottom: 2rem;
`;

const Logo = styled.img`
  width: auto;
  height: 4.5rem;
`;
